import { Heading, Blue, Green, StatusTag } from "./Primitives";
import useGithubProjects from "../../../hooks/useGithubProjects";

export default function ProjectsOutput() {
  const { projects, loading, error } = useGithubProjects("badu01");

  if (loading) {
    return (
      <div>
        <Heading>ls ~/projects</Heading>
        <div className="text-neutral-500 text-[12px]">
          fetching repositories...
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div>
        <Heading>ls ~/projects</Heading>
        <div className="text-red-400 text-[12px]">
          error: {error}
        </div>
      </div>
    );
  }

  return (
    <div>
      <Heading>ls ~/projects</Heading>

      <div className="space-y-4">
        {projects.map((project) => (
          <div key={project.id || project.name}>

            {/* Repository name + metadata */}
            <div className="flex flex-wrap items-baseline gap-2">
              <Blue>{project.name}/</Blue>

              {project.language && (
                <StatusTag status={project.language} />
              )}

              <span className="text-neutral-600 text-[12px]">
                {project.visibility || "public"}
              </span>
            </div>

            {/* Description */}
            <div className="text-neutral-400">
              {project.description || "No description provided."}
            </div>

            {/* GitHub stats */}
            <div className="flex flex-wrap gap-x-4 gap-y-1 mt-1 text-[11px] text-neutral-600">
              <span>
                ★ {project.stargazers_count ?? 0}
              </span>

              <span>
                forks: {project.forks_count ?? 0}
              </span>

              {project.language && (
                <span>
                  lang: {project.language}
                </span>
              )}

              {project.updated_at && (
                <span>
                  updated:{" "}
                  {new Date(project.updated_at).toLocaleDateString()}
                </span>
              )}
            </div>

            {/* GitHub URL */}
            {project.html_url && (
              <a
                href={project.html_url}
                target="_blank"
                rel="noreferrer"
                className="text-sky-400 hover:underline text-[12px]"
              >
                {project.html_url}
              </a>
            )}
          </div>
        ))}
      </div>

      <div className="mt-4 text-neutral-600 text-[12px]">
        <span>total: </span>
        <Green>{projects.length} repositories</Green>
      </div>

      <div className="mt-2 text-neutral-600 text-[12px]">
        tip: <Green>cd projects</Green> then{" "}
        <Green>cat &lt;name&gt;</Green> for the full README.
      </div>
    </div>
  );
}